// js/ui/TitleScreen.js
// 標題畫面：遊戲入口。提供「開始」進入選關，與「聯絡作者」收意見／支持／分享。

import { CONFIG } from '../config.js';

export class TitleScreen {
  constructor(root, { onStart } = {}) {
    this.root = root;
    this.onStart = onStart;
    this.el = document.createElement('div');
    this.el.className = 'screen hidden';
    this.root.appendChild(this.el);
  }

  show() {
    this._render();
    this.el.classList.remove('hidden');
  }

  hide() {
    this.el.classList.add('hidden');
  }

  _render() {
    const c = CONFIG.contact;
    const waLink = c.whatsapp
      ? `<a class="btn secondary" href="https://wa.me/${c.whatsapp}" target="_blank" rel="noopener">WhatsApp</a>`
      : '';
    const linksHtml = waLink + (c.links || [])
      .filter((l) => l && l.url)
      .map((l) => `<a class="btn secondary" href="${l.url}" target="_blank" rel="noopener">${l.label}</a>`)
      .join('');

    this.el.innerHTML = `
      <div class="dialog pixbox title-dialog">
        <div class="title-logo">黎先生</div>
        <div class="title-sub">準時返工</div>
        <p class="title-tagline">規劃路線、避開人潮、準時打卡。<br/>排除萬難都要返到公司。</p>
        <div class="row-btns title-mainbtns">
          <button class="btn" id="ts-start">開始</button>
          <button class="btn secondary" id="ts-contact">聯絡作者</button>
        </div>

        <div id="ts-contact-panel" class="hidden contact-panel">
          <h2>提供建議 · 支持開發</h2>
          <p class="sub">歡迎告訴我你的想法、回報問題，或分享你想要的功能。<br/>你的每一句回饋都讓黎先生行得更遠。</p>
          <div class="row-btns">
            <a class="btn" id="ts-mail" href="mailto:${c.email}?subject=${encodeURIComponent('《黎先生：準時返工》回饋')}">向老闆反映</a>
            ${linksHtml}
          </div>
          <p class="sub contact-email">${c.email}</p>
        </div>
      </div>
    `;

    this.el.querySelector('#ts-start').onclick = () => this.onStart && this.onStart();
    this.el.querySelector('#ts-contact').onclick = () => {
      const p = this.el.querySelector('#ts-contact-panel');
      p.classList.toggle('hidden');
    };
  }
}
